export default __webpack_public_path__ + "a81d72d4b91b531898f6c454dd3dfce9.png";